/* eslint-disable */
export default {
  removeParticipant: 'Rimuovi partecipante',
  confirmStr1: 'Rimuovere',
  confirmStr2: 'dalla chiamata?',
  remove: 'Rimuovi',
  cancel: 'Annulla',
  participants: 'Partecipanti',
  participant: 'Partecipante',
  conferenceCall: 'Conferenza telefonica',
  unknownNumber: 'Numero anonimo',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
